<template>
  <td class="d-flex align-items-center">
    <Modal
      v-if="selected != null"
      :open="true"
      :title="weight"
      @close="closeModal()"
    >
      <WeightEditView
        :weight="weight"
        :weight-list="weightList"
        @Save="editWeight"
      />
    </Modal>
    <div class="d-flex align-items-center">
      <RuleSmallButton
        :disabled="isLoading"
        class="btn-danger p-2 small-button-width fw-bold mx-2"
        :title="'-'"
        @click.native="deleteWeight(weight)"
      />
      <button
        :disabled="isLoading"
        type="button"
        class="btn btn-secondary  mt-1 mb-2 p-1"
        @click="select()"
      >
        <span class="fa fa-cogs" />
        <b class="mx-1">{{ weight }}</b>
      </button>
    </div>
  </td>
</template>

<script>
import Modal from '@/employees/AttendanceList/components/Modal'
import WeightEditView from '@/employees/components/PreferenceConfig/Weight/WeightEditView'
export default {
  name: 'WeightCell',
  components: {
    Modal,
    WeightEditView,
  },
  props: {
    isLoading: {
      required: true,
      type: Boolean,
    },
    weight: {
      required: true,
      type: Number,
    },
    weightList: {
      required: true,
      type: Array,
    },
  },
  data () {
    return {
      selected: null,
    }
  },
  methods: {
    deleteWeight (removedWeight) {
      this.$emit('DeleteWeight', removedWeight)
    },
    editWeight ({ oldWeight, newWeight }) {
      this.$emit('EditWeight', { oldWeight, newWeight })
      this.selected = null
    },
    select () {
      this.selected = true
    },
    closeModal () {
      this.selected = null
    },
  },
}
</script>
